import { createBrowserHistory } from 'history';
import { stripRoutingSegment } from '../utils/uriUtils';
import { removeOriginalQueryHashParamValue } from '../utils/hashFragmentHelpers';

const getCurrentUriRef = ({ pathname, search, hash }) => {
    const newHash = removeOriginalQueryHashParamValue(hash);
    const currentUriRef = stripRoutingSegment(`${pathname}${search}${newHash}`);
    return decodeURIComponent(currentUriRef);
};

export class FindingRouter {
    constructor(options) {
        const { routes, initialUriRef } = options;

        this.routes = routes;
        this.history = createBrowserHistory();
        this.previousDisplayUriRef = initialUriRef;
    }

    navigate(displayUriRef, options = {}) {
        const { replace, searchCorrectionTerm } = options;
        const { pathname, search, hash } = this.history.location;
        const currentUriRef = getCurrentUriRef({ pathname, search, hash }); // what's currently in the browser address bar minus oq hash param

        if (displayUriRef !== currentUriRef) {
            const uriRef = searchCorrectionTerm
                ? `${displayUriRef}#?oq=${searchCorrectionTerm}`
                : displayUriRef;

            if (replace) {
                this.history.replace(uriRef);
            } else {
                //update browser url bar if URI changes in the store
                this.history.push(uriRef);
                // keep track of previous push so we don't push any history twice
                this.previousDisplayUriRef = uriRef;
            }
        }
    }
}
